import React, { useMemo, useState } from "react";
import translate from "../constants/translations";
import { ssnIsValid } from "../helpers/ssn-helper";
import WarningIcon from "./warning-icon";

interface SSNFieldProps {
	cultureCode: string | null | undefined;
	ssn: string;
	onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	subjectAndBodyDisabled?: boolean;
}

export default function SSNField({
	cultureCode,
	ssn,
	onInputChange,
	subjectAndBodyDisabled = false,
}: SSNFieldProps) {
	const [showSSNValidation, setShowSSNValidation] = useState(false);

	const t = useMemo(
		() => (term: string) => translate(cultureCode, term),
		[cultureCode],
	);
	const isValid = ssnIsValid(cultureCode, ssn);

	const showSSNError = () => {
		setShowSSNValidation(!isValid);
	};

	const onSSNChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		// Preserve previous behavior where the input is uppercased before bubbling up.
		event.target.value = event.target.value.toUpperCase();
		onInputChange(event);
	};

	return (
		<div>
			<div className="gb sm form-group secure-messaging-component__required-field">
				<label className="if u-margin-top--smallest" htmlFor="ssn">
					{t("EnterSSN")}
				</label>
				<input
					id="ssn"
					name="ssn"
					className={`gb secure-messaging-component__validated-input ${showSSNValidation ? "is-invalid" : ""} secure-messaging-component__select-matched-field-width`}
					type="text"
					onChange={onSSNChange}
					onBlur={showSSNError}
					disabled={subjectAndBodyDisabled}
					placeholder={t("EnterSSNPlaceholder")}
					aria-invalid={!isValid}
					aria-required="true"
					value={ssn}
					maxLength={11}
				/>

				{showSSNValidation && (
					<div className="if col-10--sm">
						<div
							id="ssn-validation-error"
							className="if field-validation-error ecmt-field-hint ecmt-field-hint-error secure-messaging-component__center-validation secure-messaging-component__warning-text"
						>
							<WarningIcon />
							{t("SSNValidationError")}
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
